<div class="card">
	<p-chart #chartBar type="bar" [data]="basicData" [options]="basicOptions"></p-chart>

	<lib-progress-spinner *ngIf="graphLoading"></lib-progress-spinner>
</div>